import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { Subject } from 'rxjs/Rx';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import { Exploracion } from '../models/';

@Injectable()
export class ExploracionService extends RESTService<any> {

  public exploracion: Exploracion;
  public exploracio: Exploracion[];

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/resumenPaciente',
    });
  }

  /**
   * getExploracio: obtiene el listado completo de Exploracion de un paciente
   * @param pacienteId: string
   * @return any
   */
  obtenerExploracion(pacienteId: string, visita: string): any {
    let a: any = environment.api_host;
    return this._http.post(environment.api_host + 'exploracionConsulta/obtenerExploracionConsulta', {
      numeroExpediente: pacienteId,
      visita: visita,
    }).map((res: Response) => res.json())
      .catch((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

  /**
   * guardarExploracion
   * @param params: object
   * @return boolean
   */
  guardarExploracion(params: any): Observable<string> {
    return this._http.post(environment.api_host + 'exploracionConsulta/guardarExploracion', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.resultado !== undefined) {
        return respuesta.resultado;
      } else {
        return false;
      }
    }).catch((error: any) => Observable.throw(false));
  }
}



// WEBPACK FOOTER //
// ./src/services/exploracion.service.ts